var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40129 6.76019C6.11236 4.96234 6.41347 2.48553 8.03508 1.05237L12.9535 7.91218C11.1078 9.03259 8.69032 8.55794 7.40113 6.76032L7.40129 6.76019ZM5.79246 15.0335V17.3724C5.79246 18.2041 6.95069 18.2196 6.95069 17.3563V12.6009L8.0625 11.7415C8.51284 11.3933 7.73269 10.2303 7.24698 10.5914C6.37324 11.2409 5.49976 11.8904 4.62603 12.5399C5.17491 13.2724 5.7767 14.1385 5.79246 15.0336V15.0335ZM2.04628 12.735C2.30943 13.102 2.82183 13.1847 3.18342 12.9174L8.74532 8.80599C7.19372 8.30957 5.86678 6.45939 5.89608 4.83246L0.334495 8.94383C-0.0272215 9.21129 -0.108634 9.72936 0.154507 10.0963L2.04628 12.735ZM8.64507 0.60275L13.5635 7.46256C15.1851 6.02941 15.4865 3.55247 14.1974 1.75475C12.9083 -0.0432313 10.491 -0.517879 8.64504 0.60275H8.64507Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivered);
export default __webpack_public_path__ + "static/media/livered.eff669ec7a159d195dac6dd817246aba.svg";
export { ForwardRef as ReactComponent };